import { gql } from '@apollo/client';

export const CREATE_TMS_ROUTE_WITH_WAYPOINTS = gql`
    mutation CreateTmsRouteWithWaypoints($input: CreateTmsRouteWithWaypointsInput!) {
        createTmsRouteWithWaypoints(input: $input) {
            success
            code
            message
        }
    }
`;

export const UPDATE_TMS_ROUTE_WITH_WAYPOINTS = gql`
    mutation UpdateTmsRouteWithWaypoints($id: ID!, $input: UpdateTmsRouteWithWaypointsInput!) {
        updateTmsRouteWithWaypoints(id: $id, input: $input) {
            success
            code
            message
        }
    }
`;

export interface CreateTmsRouteInput {
    routeName: string;
    routeType: number;
    startWarehouseId: number;
    endWarehouseId: number | null;
    plannedTotalHours: number;
    plannedTotalMiles: number;
    carrierId: number;
}

export interface UpdateTmsRouteInput {
    routeName?: string;
    routeType?: number;
    startWarehouseId?: number;
    endWarehouseId?: number;
    plannedTotalHours?: number;
    plannedTotalMiles?: number;
    carrierId?: number;
    status?: number;
}

export interface RouteWaypointInput {
    waypointId: number;
    extWaypointId?: number | null;
    waypointOrder: number;
    waypointType: number;
    waypointStatus?: number;
    travelTime?: number | null;
    dwellTime?: number | null;
    distance?: number | null;
}

export interface CreateTmsRouteWithWaypointsInput {
    routeName: string;
    routeCode?: string;
    routeType: number;
    businessType: number;
    carrierId: number;
    status: number;
    startWarehouseId: number;
    endWarehouseId: number | null;
    plannedTotalHours?: number;
    plannedTotalMiles?: number;
    waypoints: RouteWaypointInput[];
}

export interface UpdateTmsRouteWithWaypointsInput {
    routeName: string;
    routeCode?: string;
    routeType: number;
    businessType: number;
    carrierId: number;
    status: number;
    startWarehouseId: number;
    endWarehouseId: number | null;
    plannedTotalHours?: number;
    plannedTotalMiles?: number;
    waypoints: RouteWaypointInput[];
}

export interface CreateTmsRouteResponse {
    createTmsRoute: {
        id: string;
        routeName: string;
        routeType: number;
        businessType: number;
        startWarehouseId: number;
        endWarehouseId: number;
        plannedTotalHours: number;
        plannedTotalMiles: number;
        carrierId: number;
        status: number;
        createdAt: string;
        updatedAt: string;
    };
}

export interface UpdateTmsRouteResponse {
    updateTmsRoute: {
        id: string;
        routeName: string;
        routeType: number;
        businessType: number;
        startWarehouseId: number;
        endWarehouseId: number;
        plannedTotalHours: number;
        plannedTotalMiles: number;
        carrierId: number;
        status: number;
        createdAt: string;
        updatedAt: string;
    };
}

export interface UpdateTmsRouteWithWaypointsResponse {
    updateTmsRouteWithWaypoints: {
        id: string;
        routeName: string;
        routeType: number;
        businessType: number;
        startWarehouseId: number;
        endWarehouseId: number;
        plannedTotalHours: number;
        plannedTotalMiles: number;
        carrierId: number;
        status: number;
        createdAt: string;
        updatedAt: string;
    };
}

